import React from 'react';
import styles from './AppPage.module.css';
import Application from './Application';

const AppPage = () => {
  return (
    <div className={styles.root}>
      <Application />
    </div>
  );
};

export default AppPage;
